import { of, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {LogEntry, LogLevel} from './log-entry';
import { throwError } from 'rxjs';

export abstract class LogPublisher {
  location: string | undefined;

  abstract log(record: LogEntry): Observable<boolean>;

  abstract clear(): Observable<boolean>;
}

export class LogConsole extends LogPublisher {
  log(entry: LogEntry): Observable<boolean> {
    // Log to console
    if (entry.level === LogLevel.Error || entry.level === LogLevel.Fatal) {
      console.error(entry.buildLogString());
    } else if (entry.level === LogLevel.Warn) {
      console.warn(entry.buildLogString());
    } else {
      console.log(entry.buildLogString());
    }
    return of(true);
  }

  clear(): Observable<boolean> {
    console.clear();
    return of(true);
  }
}

export class LogLocalStorage
  extends LogPublisher {
  constructor() {
    // Must call super() from derived classes
    super();
    // Set location
    this.location = 'logging';
  }

  // Append log entry to local storage
  log(entry: LogEntry): any {
    // let ret = false;
    // let values: LogEntry[];
    //
    // try {
    //   // Get previous values from local storage
    //   values = JSON.parse(localStorage.getItem(this.location)) || [];
    //   // Add new log entry to array
    //   values.push(entry);
    //   // Store array into local storage
    //   localStorage.setItem(this.location,
    //     JSON.stringify(values));
    //
    //   // Set return value
    //   ret = true;
    // } catch (ex) {
    //   // Display error in console
    //   console.log(ex);
    // }
    //
    // return of(ret);
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    if (typeof this.location === "string") {
      localStorage.removeItem(this.location);
    }
    return of(true);
  }
}

export class LogWebApi extends LogPublisher {
  constructor(private http: HttpClient) {
    // Must call super() from derived classes
    super();
    // Set location
    this.location = '/api/log';
  }

  // Add log entry to back end data store
  log(entry: LogEntry): Observable<boolean> {
    const headers = new Headers(
      {'Content-Type': 'application/json'});
    return new Observable<boolean>(observer => {
      observer.next(true);
      // TODO: store logs in API
      // this.http.post(environment.apiUrl + 'log',
      //     entry).subscribe(r => {
      //     observer.next(true);
      // }, e => {
      //     observer.next(false);
      // });
    });
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    // TODO: Call Web API to clear all value
    return of(true);
  }

  private handleErrors(error: any): any {
    const errors: string[] = [];
    let msg = '';

    msg = 'Status: ' + error.status;
    msg += ' - Status Text: ' + error.statusText;
    if (error.json()) {
      msg += ' - Exception Message: ' +
        error.json().exceptionMessage;
    }
    errors.push(msg);

    console.error('An error occurred', errors);
    // return Observable.throw(errors);
  }
}
